export const blockIconsFileFileDownloadDone = (
	<span className='material-symbols-outlined'>file_download_done</span>
);
